import { request } from '@/api-client';

function updateSubscription(uri: string, xsrf: string, enabled: boolean, savedSearchId: number) {
  return request({
    uri,
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'x-mp-xsrf': xsrf, 'Content-Type': 'application/json' },
    body: JSON.stringify({ enabled, savedSearchId: String(savedSearchId) }),
  });
}

export const updateEmailSubscription = (xsrf: string, enabled: boolean, savedSearchId: number) =>
  updateSubscription('/lrp/api/saved-searches/update-email-subscription', xsrf, enabled, savedSearchId);

export const updatePushSubscription = (xsrf: string, enabled: boolean, savedSearchId: number) =>
  updateSubscription('/lrp/api/saved-searches/update-push-subscription', xsrf, enabled, savedSearchId);
